<div class="benefits-container" *ngIf="isDisney || isUniversal">
  <img [src]="isDisney ? disneyURl : universalUrl" [alt]="altImage" />
</div>
<div
  *ngIf="!temporarilyHidden"
  class="benefits-container"
  [ngClass]="{ 'disney-container': isDisney, 'universal-container': isUniversal }"
>
  <div
    class="benefits-container--title"
    [ngClass]="{
      'disney-container__disney-title': isDisney,
      'universal-container__universal-title': isUniversal
    }"
  >
    <span *ngIf="isDisney" i18n="@@disney__benefit__resort-hotels"
      >Beneficios de Hoteles Resort Disney</span
    >
    <span *ngIf="isUniversal" i18n="@@universal__benefit__resort-orlando"
      >Beneficios de Universal Orlando Resort</span
    >
    <button
      [mb-expandable-panel]="panel"
      class="benefits-container--title__expand-button"
      (click)="togglePanel()"
    >
      <mb-icon icon="down" [verticalFlip]="openPanel"></mb-icon>
    </button>
  </div>
  <mb-expandable-panel [expanded]="true" #panel>
    <ul
      class="benefits-container--list"
      [ngClass]="{
        'disney-container__disney-list': isDisney,
        'universal-container__universal-list': isUniversal
      }"
    >
      <ng-container *ngIf="isDisney">
        <li>
          <mb-icon icon="parking"></mb-icon>
          <span i18n="@@disney__benefit__parking"
            >Estacionamiento con costo y Traslados Gratis</span
          >
        </li>
        <li>
          <mb-icon icon="transfer"></mb-icon>
          <span i18n="@@disney__benefit__transport">Magical Express</span>
        </li>
        <li>
          <mb-icon icon="wifi"></mb-icon>
          <span i18n="@@disney__benefit__wifi">Wifi libre</span>
        </li>
      </ng-container>
      <ng-container *ngIf="isUniversal">
        <li>
          <mb-icon icon="ticket"></mb-icon>
          <span i18n="@@universal__benefit__express-pass">Pase Universal Express Unlimited</span>
        </li>
        <li>
          <mb-icon icon="clock"></mb-icon>
          <span i18n="@@universal__benefit__early-entry">Entrada Temprana</span>
        </li>
        <li>
          <mb-icon icon="transfer"></mb-icon>
          <span i18n="@@universal__benefit__transport">Transporte gratuito</span>
        </li>
        <li>
          <mb-icon icon="bank-credit-card"></mb-icon>
          <span i18n="@@universal__benefit__key-payments">Pagá con la llave de la habitación</span>
        </li>
        <li>
          <mb-icon icon="packages"></mb-icon>
          <span i18n="@@universal__benefit__merchandise-delivery">Entrega de mercancía</span>
        </li>
      </ng-container>
    </ul>
  </mb-expandable-panel>
</div>
